import React, { createContext, useMemo, useState } from "react";

export const NavigationVisibilityContext = createContext({
    hideHeader: false,
    setHideHeader: () => {},
    hideNav: false,
    setHideNav: () => {},
});

export function NavigationVisibilityProvider({ children }) {
    const [hideHeader, setHideHeader] = useState(false);
    const [hideNav, setHideNav] = useState(false);

    const value = useMemo(
        () => ({
            hideHeader,
            setHideHeader,
            hideNav,
            setHideNav,
        }),
        [hideHeader, hideNav]
    );

    return (
        <NavigationVisibilityContext.Provider value={value}>
            {children}
        </NavigationVisibilityContext.Provider>
    );
}
